import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'
export default {
  namespaced: true,
  state: {
    url: null,
    isLoading: false,
    response: false,
    tempFile: [],
    latestPdf: null
  },
  actions: {
    async upload({commit}, formData) {
      commit('setLoading', true)
      return await axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          commit('setURL', response[0].url)
          commit('setLoading', false)
          // alert.success('Upload file thành công!')
          return response[0].id || response[0]._id
        })
        .catch(e => alert.error(e))
    },
    async uploadPdfForm({commit}, formData) {
      return await axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          commit('setLatestPdf', response[0].url)
          return response[0].url
        })
        .catch(e => alert.error(e))
    },
    async uploadMany({commit}, formData) {
      commit('setLoading', true)
      return await axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          const ids = response.map(item => item.id || item._id)
          commit('setLoading', false)
          commit('setTempFile', response)
          // alert.success('Upload file thành công!')
          return ids
        })
        .catch(e => {
          alert.error(e)
          commit('setLoading', false)
          console.error(e)
        })
    },
    async destroy({commit}, id) {
      commit('setLoading', true)
      return await axios.delete(DESTROY_API + id).catch(e => alert.error(e))
    }
  },
  mutations: {
    setLatestPdf(state, url) {
      state.latestPdf = url
    },
    setURL(state, url) {
      state.url = url
    },
    setTempFile(state, files) {
      state.tempFile = files
    },
    setLoading(state, bool) {
      state.isLoading = bool
    }
  },
  getters: {
    url: state => {
      return state.url
    },
    tempFile: state => {
      return state.tempFile
    },
    isLoading: state => {
      return state.isLoading
    }
  }
}
